<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-21 21:11:52
 * @LastEditTime: 2022-10-10 23:05:15
 * @LastEditors: chenguobiao
-->
<template>
  <div class="dialog" v-if="visible">
    <div class="dialog__masker"></div>
    <div class="dialog__box">
      <!-- <div class="dialog__bg">
        <img src="@/render/assets/images/personal/dialog_bg.png">
      </div> -->
      <div class="dialog__desc" v-html="desc"></div>
      <div class="dialog__options">
        <div class="option" v-if="showCancel" @click="cancel">{{cancelTxt}}</div>
        <div class="option" @click="confirm">{{confirmTxt}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from '@/render/components/dialog/mixin'
export default {
  mixins: [dialogMixin],
  props: {
    desc: {
      type: String,
      // require: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    cancelTxt: {
      type: String,
      default: '取消'
    },
    confirmTxt: {
      type: String,
      default: '确定'
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  &__masker {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
  }
  &__box {
    position: relative;
    width: val(400);
    height: val(200);
    background: url(../../../assets/images/dialog/dialog_bg_01.png) left top
      no-repeat;
    background-size: 100%;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__desc {
    // padding-top: val(88);
    position: relative;
    top: val(10);
    padding: 0 val(46);
    line-height: val(24);
    font-size: val(16);
    color: #502700;
    ::v-deep span {
      color: red;
    }
  }
  &__options {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    margin-bottom: val(-21);
    display: flex;
    justify-content: center;
    .option {
      width: val(120);
      line-height: val(42);
      border-radius: val(37);
      font-size: val(18);
      text-align: center;
      &:last-of-type {
        color: #6a6a6a;
        background: linear-gradient(
          360deg,
          #8d8d8d 0%,
          #c1c1c1 56%,
          #e9e9e9 100%
        );
      }
      &:first-of-type {
        margin-right: val(30);
        color: #fff;
        background: linear-gradient(360deg, #b26113 0%, #fdae5f 100%);
      }
    }
  }
}
</style>
